import { useAppSelector } from 'universal-scripts'

export function useUserAcl() {
  const acl = useAppSelector((state) => state.user?.acl ?? [])
  return acl
}
